import { ButtonLarge } from './styles';

export default ButtonLarge;
